import React from 'react'
import { AiFillDelete } from 'react-icons/ai'
import { MdOutlineRemoveDone } from 'react-icons/md'
import axios from 'axios';
import Swal from 'sweetalert2'
import { ipAddress } from '../../ipAddress';

interface Props {
    group: Group
}
interface Group {
    name: string,
    id: number,
    isDone: number,
    date: string,
}


const ToDoEndGroup: React.FC<Props> = ({ group }) => {



    const deleteGroup = (e: React.FormEvent, id: number) => {
        e.preventDefault();
        Swal.fire({
            title: 'Czy jesteś pewien?',
            text: "Element zostanie usunięty",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, move it!',
            heightAuto: false,

        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(ipAddress + '/deleteGroup', {
                    id: id,
                })
                axios.post(ipAddress + '/deleteTask2', {
                    id: id,
                })
            }
        })

            .then((response) => {

            })

            .catch(function (error) {
                console.log("error!")

            })
    }





    const handleChange = (e: React.FormEvent, id: number, isDone: number, name: string) => {
        if (isDone == 1) {
            isDone = 0
        } else {
            isDone = 1
        }
        Swal.fire({
            title: 'Czy jesteś pewien?',
            text: `Element ${name} zostanie przeniesony do zaplanowanych`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, move it!',
            heightAuto: false,

        }).then((result) => {
            if (result.isConfirmed) {

                axios.post(ipAddress + '/doneGroup', {
                    id: id,
                    isDone: isDone,
                    date: ''
                })
            }
        })


    };



    return (

        <div className='allGroupsEnd'>
            <span id='name' >{group.name}</span>
            <span className='icon' onClick={(e) => handleChange(e, group.id, group.isDone, group.name)} ><MdOutlineRemoveDone /></span>
            <span className='icon' onClick={(e) => deleteGroup(e, group.id)}><AiFillDelete /></span>


        </div>





    )
}

export default ToDoEndGroup